import { DateTime } from "luxon";

const ART_ZONE = "America/Argentina/Buenos_Aires";

/** Las fechas de prioridad llegan como hora de pared de Buenos Aires, sin offset explícito. */
export function parseArtDateTime(value: string): DateTime | null {
  const normalized = value.trim();
  const withMillis = DateTime.fromFormat(normalized, "yyyy-MM-dd HH:mm:ss.SSS", { zone: ART_ZONE });
  if (withMillis.isValid) return withMillis;

  const withoutMillis = DateTime.fromFormat(normalized.substring(0, 19), "yyyy-MM-dd HH:mm:ss", { zone: ART_ZONE });
  return withoutMillis.isValid ? withoutMillis : null;
}

export function parseArtDateTimeToMillis(value?: string): number | null {
  if (!value) return null;
  return parseArtDateTime(value)?.toMillis() ?? null;
}

/**
 * Diferencia entre el reloj del servidor y el del cliente, medida en el instante en que llegó la
 * respuesta. Sumado a `Date.now()` reconstruye la hora de servidor en cualquier momento posterior,
 * sin depender de cuándo se montó el componente que lo consume.
 *
 * @param fechaInicioContador Hora de servidor incluida en la respuesta de prioridad.
 * @param recibidoEnMs `Date.now()` capturado al resolverse el request.
 * @returns El offset en milisegundos, o null si la fecha de servidor no es parseable.
 */
export function calcularOffsetRelojServidor(
  fechaInicioContador: string | undefined,
  recibidoEnMs: number
): number | null {
  const serverNowMs = parseArtDateTimeToMillis(fechaInicioContador);
  if (serverNowMs === null) return null;
  return serverNowMs - recibidoEnMs;
}
